document.addEventListener("DOMContentLoaded", function (event) {

    /**
     * Slider w bloku "Poznajmy się"
     */
   const meetUsSlidersInit = () => {
        const postSliders = document.querySelectorAll('.c-meet-us__swiper');
        if (postSliders.length > 0) {
            postSliders.forEach(gallery => {
                new Swiper(gallery, {
                    slidesPerView: 1.4,
                    slideToClickedSlide: true,
                    loop: true,
                    spaceBetween: 32,
                    pauseOnMouseEnter: true,
                    speed: 800,
                    // autoplay: {
                    //     delay: 2500,
                    //     disableOnInteraction: false
                    // },
                    navigation: {
                        nextEl: gallery.closest('.c-meet-us__box').querySelector('.c-meet-us__arrow--next'),
                        prevEl: gallery.closest('.c-meet-us__box').querySelector('.c-meet-us__arrow--prev')
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2
                        },
                        992: {
                            slidesPerView: 4
                        }
                    }
                });
            });
        }

    };

    meetUsSlidersInit();

    if (window.acf) {
        window.acf.addAction('render_block_preview', meetUsSlidersInit);
    }

    const meetUsSlidersReInit = () => {

        const cMeetUsTargets = document.querySelectorAll('.c-meet-us__target');

        const disableOthersTargets = (target) => {
            const newCMeetUsTargets = target.closest('.c-meet-us__box').querySelectorAll('.c-meet-us__target');
            newCMeetUsTargets.forEach(target => {
                if (target.classList.contains('c-meet-us__target--active')) {
                    target.classList.remove('c-meet-us__target--active');
                }
            });
        };

        const hideOthersSliders = (target) => {
            const newCMeetUsTargets = target.closest('.c-meet-us__box').querySelectorAll('.c-meet-us__target');
            newCMeetUsTargets.forEach(target => {
                const cMeetsUsSwipers = target.closest('.c-meet-us__box').querySelectorAll('.c-meet-us__swiper');
                cMeetsUsSwipers.forEach(cMeetsUsSwiper => {
                    if (!cMeetsUsSwiper.classList.contains('c-meet-us__swiper--hide')) {
                        cMeetsUsSwiper.classList.add('c-meet-us__swiper--hide');
                    }
                });
            });
        };

        cMeetUsTargets.forEach(target => {
            target.addEventListener('click', e => {
                e.preventDefault();
                hideOthersSliders(target);
                disableOthersTargets(target);
                if (!target.classList.contains('c-meet-us__target--active')) {
                    target.classList.add('c-meet-us__target--active');
                }
                const dataTarget = target.getAttribute('data-target');
                const cMeetsUsSwiper = target.closest('.c-meet-us__box').querySelector('[data-id="' + dataTarget + '"]');
                if (cMeetsUsSwiper.classList.contains('c-meet-us__swiper--hide')) {
                    cMeetsUsSwiper.classList.remove('c-meet-us__swiper--hide');
                }
            });
        });

    };

    meetUsSlidersReInit();

    if (window.acf) {
        window.acf.addAction('render_block_preview', meetUsSlidersReInit);
    }

});